var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.02,
    height: 21.959,
    viewBox: "0 0 15.02 21.959",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_21236",
    "data-name": "Group 21236",
    transform: "translate(-819.942 -431.864)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10891",
    "data-name": "Path 10891",
    d: "M22.508,19.817a.316.316,0,0,0,.249.128h0a.315.315,0,0,0,.248-.121c.261-.333,6.385-8.2,6.385-13.19a6.634,6.634,0,0,0-13.267,0c0,1.909,1.077,4.713,3.2,8.333,1.57,2.674,3.162,4.829,3.178,4.851M22.762.63a6.01,6.01,0,0,1,6,6c0,4.209-4.823,10.9-6,12.467-1.159-1.626-6.01-8.65-6.01-12.467a6.01,6.01,0,0,1,6-6",
    transform: "translate(804.691 432.014)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10892",
    "data-name": "Path 10892",
    d: "M86.383,66.437a3.813,3.813,0,1,0-3.813,3.813h0a3.817,3.817,0,0,0,3.813-3.813M82.569,69.62a3.183,3.183,0,1,1,3.183-3.183h0a3.186,3.186,0,0,1-3.183,3.183",
    transform: "translate(744.883 372.21)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10893",
    "data-name": "Path 10893",
    d: "M10.574,395.139a.315.315,0,0,0-.077.626c2.714.333,3.592.961,3.592,1.213,0,.473-2.375,1.394-6.73,1.394s-6.73-.922-6.73-1.394c0-.27.861-.823,3.173-1.157a.315.315,0,0,0-.09-.624C2.02,395.442,0,395.95,0,396.979,0,398.464,4.4,399,7.36,399s7.36-.539,7.36-2.025c0-1.158-2.6-1.649-4.146-1.839",
    transform: "translate(820.092 54.67)",
    fill: "#040227",
    stroke: "#040227",
    strokeWidth: 0.3
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocation);
export default __webpack_public_path__ + "static/media/icon_location.0a493af0e86135bb2bd5971f08c8c9f1.svg";
export { ForwardRef as ReactComponent };